export enum EventTypeEnum {
  LINKING = 'LINKING',
}
